import React from 'react';
import { Container, Row, Col, Button, Card, Carousel } from 'react-bootstrap';
import '../App.css';

// Use require to ensure webpack processes these images
const heroImg = require('../assets/defaultImage2.jpg');
const serviceImg1 = require('../assets/defaultimage1.jpg');
const serviceImg2 = require('../assets/defaultImage2.jpg');
const serviceImg3 = require('../assets/defaultImage3.jpg');

const servicesPreview = [
    { title: 'Landscape Design + Build', desc: 'Custom designs and professional installations to make your outdoor dreams a reality.', img: serviceImg1 },
    { title: 'Maintenance Programs', desc: 'Weekly mowing, fertilization, pruning, and seasonal care to keep your yard pristine.', img: serviceImg2 },
    { title: 'Hardscapes & Walls', desc: 'Patios, retaining walls, and outdoor living spaces built to last.', img: serviceImg3 }
];

const testimonials = [
    { quote: 'Nicer Lawns transformed our backyard into a beautiful outdoor living space. Professional and responsive.', author: 'S. Thompson' },
    { quote: 'Reliable service and fantastic attention to detail. Our lawn has never looked better.', author: 'M. Garcia' },
    { quote: 'Great team, fair pricing, and excellent results. Highly recommend!', author: 'D. Patel' }
];

const HomePage = () => {
    return (
        <div>
            <Carousel fade>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={heroImg}
                        alt="Landscape 1"
                    />
                    <Carousel.Caption className="text-start">
                        <h2>Thoughtful & Creative Landscaping</h2>
                        <p>Design, build, and maintain beautiful outdoor spaces across Kansas City.</p>
                        <div>
                            <Button href="/contact-us" variant="success" className="me-2">Schedule Consultation</Button>
                            <Button href="/services" variant="outline-light">Our Services</Button>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={serviceImg1}
                        alt="Landscape 2"
                    />
                    <Carousel.Caption>
                        <h2>Maintenance Programs</h2>
                        <p>Keep your property looking its best year-round with tailored maintenance plans.</p>
                        <div>
                            <Button href="/services" variant="success" className="me-2">View Plans</Button>
                            <Button href="/contact-us" variant="outline-light">Get a Quote</Button>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={serviceImg3}
                        alt="Landscape 3"
                    />
                    <Carousel.Caption className="text-end">
                        <h2>Hardscapes & Outdoor Living</h2>
                        <p>Patios, firepits, and retaining walls built to last and look great.</p>
                        <div>
                            <Button href="/services" variant="success" className="me-2">Our Work</Button>
                            <Button href="/contact-us" variant="outline-light">Contact</Button>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>

            <Container className="my-5">
                <Row>
                    <Col>
                        <h2 className="mb-3">Landscaping Services</h2>
                        <p className="text-muted">From design and installation to seasonal maintenance — we cover it all.</p>
                    </Col>
                </Row>

                <Row className="mt-4">
                    {servicesPreview.map((s, i) => (
                        <Col key={i} md={4} className="mb-4">
                            <Card className="h-100 shadow-sm">
                                <Card.Img variant="top" src={s.img} style={{height:180, objectFit:'cover'}} />
                                <Card.Body>
                                    <Card.Title>{s.title}</Card.Title>
                                    <Card.Text className="text-muted">{s.desc}</Card.Text>
                                    <Button href="/services" variant="success">Learn More</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Row className="mt-5">
                    <Col>
                        <h3 className="mb-4">What customers say</h3>
                    </Col>
                </Row>
                <Row>
                    {testimonials.map((t, i) => (
                        <Col key={i} md={4} className="mb-3">
                            <Card className="h-100">
                                <Card.Body>
                                    <blockquote className="blockquote mb-0">
                                        <p className="text-muted">“{t.quote}”</p>
                                        <footer className="blockquote-footer">{t.author}</footer>
                                    </blockquote>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default HomePage;
